var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57143 13V11.2857C9.57143 10.8311 9.75204 10.395 10.0735 10.0735C10.395 9.75204 10.8311 9.57143 11.2857 9.57143H13M9.57143 1V2.71429C9.57143 3.16894 9.75204 3.60498 10.0735 3.92647C10.395 4.24796 10.8311 4.42857 11.2857 4.42857H13M1 9.57143H2.71429C3.16894 9.57143 3.60498 9.75204 3.92647 10.0735C4.24796 10.395 4.42857 10.8311 4.42857 11.2857V13M1 4.42857H2.71429C3.16894 4.42857 3.60498 4.24796 3.92647 3.92647C4.24796 3.60498 4.42857 3.16894 4.42857 2.71429V1",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullscreen);
export default __webpack_public_path__ + "static/media/exit-fullscreen.6e71297559113a85639670c7917c6f82.svg";
export { ForwardRef as ReactComponent };